// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/glider-traffic.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/glider-traffic/glider-traffic.js';

mount([g0]);
